const aboutData = {
    'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    'videos': [
        {
            'name': 'I am <span class="bold">video 1</span>',
            'url': 'https://www.youtube-nocookie.com/embed/_NSSBOarEfc?controls=0'
        },
        {
            'name': 'I am <span class="bold">video 2</span>',
            'url': 'https://www.youtube-nocookie.com/embed/pMQdu_7uxQU?controls=0'
        },
        {
            'name': 'I am <span class="bold">video 3</span>',
            'url': 'https://www.youtube-nocookie.com/embed/08h7Lo5JNSw?controls=0'
        },
        {
            'name': 'I am <span class="bold">video 4</span>',
            'url': 'https://www.youtube-nocookie.com/embed/Cxk7tSSjmhg?controls=0'
        },
        {
            'name': 'I am <span class="bold">video 5</span>',
            'url': 'https://www.youtube-nocookie.com/embed/WKIgo3RNT80?controls=0'
        },
        {
            'name': 'I am <span class="bold">video 6</span>',
            'url': 'https://www.youtube-nocookie.com/embed/E3exg2KgHMc?controls=0'
        }
    ],
    'doc': '/docs/doc.pdf'
}

export default aboutData